export default {
  topology: {
    title: "Node Title",
    topologyNode: "Topology Node",
    topologyNodeParam: "Topology Node Param",
    topologyNodeColumn: "Topology Node Column",
    topologyNodeItem: "Topology Node Item",
    nodeCode: "Node Code",
    nodeIcon: "Node Icon",
    sqlQuery: "Child Nodes SQL Query",
    sqlQueryTips: "This query will get all related child nodes from this root node. Please put this {params} to include parameters from 'SQL Query Params Configuration'.",
    shortSql: "Popup Info SQL",
    shortSqlTips: "Note: <br> - Put {params} in WHERE clause to include parameters from 'Popup Info SQL Params Configuration'. <br> - There MUST be only 2 columns in result, name them '<strong>popup_text</strong>' and '<strong>popup_image</strong>'",
    detailSql: "Detail SQL",
    detailSqlTips: "Query to get all related information of the node.<br> Note:  <br> - Put {params} in WHERE clause to include parameters from 'Detail SQL Params Configuration' <br> - There MUST be only 2 columns in result, name them '<strong>detail_text</strong>' and '<strong>detail_image</strong>'",
    resultColumns: "Get child nodes",
    childNodes: "Child Nodes Configuration",
    childNodesTips: "These are child nodes that were gotten from above Sql query. <br> This is used to config the child nodes. <br> Format: column_name|node_code. <br> Eg.: <strong>username|customer</strong>",
    checkQuery: "Check Query",
    queryStatus: "Query Status",
    selectIcon: "Select Icon",
    selectColor: "Select Color",
    iconSize: "Icon Size",
    queryParams: "SQL Query Params Configuration",
    queryParamsTips: "This is used to map the query parameter with input variables. <br> <strong style='background-color: #e53935'>These values MUST BE VALID columns from SQL Query's tables.</strong><br> Format: param_name1|param_name2|... <br> Eg.: <strong>id|fraud_id</strong>",
    nameKey: "Column Name for the name of node",
    nameKeyTips: "This is used to define which column name will be use as the unique ID of node. <br> Eg.: username",
    valueKey: "Column Name for the display value of node",
    valueKeyTips: "This is used to define which column name will be use as the display value of node. <br> Eg.: full_name",
    shortParams: "Popup Info SQL Params Configuration",
    shortParamsTips: "This is used to map the query parameter with input variables. <br> <strong style='background-color: #e53935'>These values MUST BE VALID columns from Popup Info SQL's tables.</strong><br> Format: param_name1|param_name2|... <br> Eg.: <strong>user_id|imei</strong>",
    shortLimit: "How many items you want to display in popup?",
    shortLimitTips: "",
    detailParams: "Detail SQL Params Configuration",
    detailParamsTips: "This is used to map the query parameter with input variables. <br> <strong style='background-color: #e53935'>These values MUST BE VALID columns from Detail SQL's tables.</strong><br> Format: param_name1|param_name2|... <br> Eg.: <strong>user_id|imei</strong>",
    detailImage: "Detail SQL Image Configuration",
    detailImageTips: "This is used to map the column and value that defines the row is an image instead of text. <br> Format: column_name|column_value <br> Eg.: <strong>info_type|3</strong>",
    showDetail: "Show Detail Information",
    hideDetail: "Hide Detail Information",

  }
};
